import { IAgendaEduAccessInfo } from '../interfaces/iagenda-edu-access-info';

export class AccessInfo {

  static getAccessInfo() {
    const accessInfo: IAgendaEduAccessInfo = {
      accessToken: this.getAccessToken(),
      studentToken: this.getStudent(),
      responsibleToken: this.getResponsible(),
      studentId: this.getStudentID(),
      mainStudentServiceId: this.getMainStudentServiceId()
    };

    return accessInfo;
  }

  private static getResponsible(): string {
    let ret: string | null = sessionStorage.getItem('responsible');
    return ret ? ret : '';
  }

  private static getStudent(): string {
    let ret: string | null = sessionStorage.getItem('student');
    return ret ? ret : '';
  }

  private static getAccessToken(): string {
    let ret: string | null = sessionStorage.getItem('accessToken');
    return ret ? ret : '';
  }

  private static getStudentID() {
    let ret: string | null = sessionStorage.getItem('studentID')
    return ret ? ret : '';
  }

  private static getMainStudentServiceId() {
    let ret: string | null = sessionStorage.getItem('mainStudentServiceId')
    return ret ? ret : '';
  }

  static setAccessInfo(
    accessToken: string,
    student: string,
    responsible: string,
  ): void {
    if (this.getAccessToken() != accessToken) this.setAccessToken(accessToken);
    if (this.getStudent() != student) this.setStudent(student);
    if (this.getResponsible() != responsible) this.setResponsible(responsible);
  }

  private static setAccessToken(value: string) {
    sessionStorage.setItem('accessToken', value);
  }

  private static setResponsible(value: string) {
    sessionStorage.setItem('responsible', value);
  }

  private static setStudent(value: string) {
    sessionStorage.setItem('student', value);
  }

  public static setStudentID(value: string) {
    sessionStorage.setItem('studentID', value);
  }

  public static setMainStudentServiceId(value: string) {
    sessionStorage.setItem('mainStudentServiceId', value);
  }
}
